import authRoutes from '../routes/authRoutes';
import userRoutes from '../routes/userRoutes';
import Ceremonies from './components/Ceremonies';
import EmailLogs from './components/EmailLogs';
import EmailTemplates from './components/EmailTemplates';
import EmailTemplate from './components/EmailTemplate';
import Songs from './components/Songs';
import Blocks from './components/Blocks';
import Root from './components/Root';
import Code from './components/Code';
import AdminClientsOverview from './components/admin/ClientsOverview.vue';
import AdminUsersOverview from './components/admin/UsersOverview.vue';
import UsersOverview from './components/UsersOverview.vue';
import Impersonate from '../components/Impersonate';
import CorporateStyle from './components/CorporateStyle.vue';
import WelcomeSigns from './components/WelcomeSigns.vue';
import BlockRenderOverview from './components/admin/BlockRenderOverview.vue';
import WelcomeSignOverrides from './components/WelcomeSignOverrides.vue';

const routes = [
    {
        path: '/',
        component: Root,
        meta: {
            guest: true,
            auth: true,
        },
    },
    {
        path: '/code/:code',
        component: Blocks,
        name: 'blocks',
        meta: {
            guest: true,
            auth: true,
        },
    },
    {
        path: '/code',
        component: Code,
        name: 'code',
        meta: {
            guest: true,
        },
    },
    {
        path: '/ceremonies',
        component: Ceremonies,
        name: 'ceremonies',
    },
    {
        path: '/songs',
        component: Songs,
        name: 'songs',
    },
    {
        path: '/email-templates',
        component: EmailTemplates,
        name: 'email_templates',
    },
    {
        path: '/email-templates/:type',
        component: EmailTemplate,
        name: 'email_template',
    },
    {
        path: '/email-logs',
        component: EmailLogs,
        name: 'email_logs',
    },
    {
        path: '/corporate-style',
        component: CorporateStyle,
        name: 'corporate_style',
    },
    {
        path: '/admin/clients-overview',
        component: AdminClientsOverview,
        name: 'admin-clients-overview',
        meta: {
            auth: true,
        },
    },
    {
        path: '/admin/users',
        component: AdminUsersOverview,
        name: 'admin-users-overview',
        meta: {
            auth: true,
        },
    },
    {
        path: '/admin/blocks/renders',
        component: BlockRenderOverview,
        name: 'admin-block-renders-overview',
        meta: {
            auth: true,
        },
    },
    {
        path: '/impersonate/:token',
        component: Impersonate,
        meta: {
            auth: true,
            guest: true
        }
    },
    {
        path: '/users',
        component: UsersOverview,
        name: 'users',
        meta: {
            auth: true,
        }
    },
    {
        path: '/manage/welcome-signs',
        component: WelcomeSigns,
        name: 'welcomeSigns',
        meta: {
            auth: true,
        },
    },
    {
        path: '/welcome-signs',
        component: WelcomeSignOverrides,
        name: 'welcomeSignOverrides',
        meta: {
            auth: true,
        },
    },
    ...authRoutes,
    ...userRoutes,

    {
        path: '*',
        beforeEnter: (to, from, next) => {
            return next('/');
        },
        meta: {
            guest: true
        }
    }
];

export default routes;
